import Keycloak, { type KeycloakInitOptions } from 'keycloak-js';

let _keycloak: Keycloak | null = null;

export function initKeycloak(url: string, realm: string, clientId: string): Keycloak {
  if (_keycloak) return _keycloak;
  _keycloak = new Keycloak({ url, realm, clientId });
  return _keycloak;
}

export function getKeycloak(): Keycloak {
  if (!_keycloak) throw new Error('Keycloak not initialized');
  return _keycloak;
}

export const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  flow: 'standard',
};

export const TOKEN_MIN_VALIDITY = 30;
